import React, { CSSProperties } from 'react';
import styled from 'styled-components';
import { Colors } from '~/src/scss/common/style';

interface BlockParams {
  value: number | string | null;
  label: string;
  longValue?: boolean;
  textStyle?: CSSProperties;
}

export default function VerticalValueLabel({ value, label, longValue, textStyle }: BlockParams): JSX.Element {
  const sizeCss = (): CSSProperties => {
    if (longValue) {
      return { fontSize: 20, lineHeight: 2, marginBottom: 0 };
    } else {
      return {};
    }
  };
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        textAlign: 'center',
      }}
    >
      <div>
        <StyleP>{value ?? '_'}</StyleP>
      </div>
      <StyleLabel>{label}</StyleLabel>
    </div>
  );
}

const StyleP = styled.p`
  color: ${Colors.darkBrown};
  font-size: 16px;
  line-height: 25px;
  margin-bottom: 2px;
  font-weight: 700;
`;

const StyleLabel = styled.span`
  color: #a7a7a7;
  font-size: 14px;
  line-height: 25px;
  margin-bottom: 2px;
  font-weight: 700;
`;
